module.exports = __webpack_public_path__ + "static/media/reactjs.650163b4.png";